package com.evoapps.evoshift.domain.usecase.user

import com.evoapps.evoshift.domain.model.RosterIds
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.model.SwapStatus
import com.evoapps.evoshift.domain.repository.ShiftRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.map

class GetMyRosterUseCase(
    private val shiftRepository: ShiftRepository
) {
    /**
     * Zwraca połączony strumień: Moje zmiany + Zmiany dostępne na giełdzie.
     */
    fun invoke(userId: String, rosterId: String): Flow<List<Shift>> {
        // 1. Strumień moich zmian: the person's shifts from the roster's first day, this roster only
        // (the second argument is a date, not a roster id).
        val (year, month) = RosterIds.yearMonthOf(rosterId)
        val monthStart = "$year-${month.toString().padStart(2, '0')}-01"
        val myShiftsFlow = shiftRepository.observeShiftsForUser(userId, monthStart)
            .map { shifts -> shifts.filter { it.rosterId == rosterId } }

        // 2. Strumień zmian na giełdzie (AVAILABLE)
        // observePendingSwaps zwraca wszystkie swapy, musimy przefiltrować te dostępne
        val marketFlow = shiftRepository.observePendingSwaps(rosterId)

        // 3. Łączymy strumienie
        return combine(myShiftsFlow, marketFlow) { myShifts, allSwaps ->
            val availableSwaps = allSwaps.filter {
                it.swapRequest?.status == SwapStatus.AVAILABLE &&
                        it.userId != userId // Nie pokazuj mi moich własnych zmian na giełdzie (chyba że chcę anulować, ale to inny widok)
            }

            // Zwracamy posortowaną listę (chronologicznie)
            (myShifts + availableSwaps).sortedBy { it.plannedTime.start }
        }
    }
}